if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.stickyATCButton = document.querySelector('.sticky-atc-button__submit');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';

      this.greenhouse = this.dataset.greenhouse;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      if (this.stickyATCButton) {
        this.stickyATCButton.setAttribute('aria-disabled', true);
        this.stickyATCButton.classList.add('loading');
        this.stickyATCButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      // checking if there are added upsells, if yes, add them to the form data
      const addedUpsells = document.querySelectorAll('.upsells-drawer li:not(.bundle-title)');
      if(addedUpsells?.length > 0) {
        addedUpsells.forEach((upsell) => {
          const variantId = upsell.dataset.upsellId;
          const quantity = upsell.dataset.upsellQuantity;

          // mini bundle Attributes
          const bundleId = upsell.dataset.bundleId;
          const bundlePartsCount = upsell.dataset.bundlePartsCount;
          const bundleDiscountPercentage = upsell.dataset.discountPercantage;
          if(bundleId && bundlePartsCount && quantity && bundleDiscountPercentage){
            formData.append(`items[${variantId}][properties][_bundle_id]`, bundleId);
            formData.append(`items[${variantId}][properties][_bundle_parts_count]`, bundlePartsCount);
            formData.append(`items[${variantId}][properties][_bundle_part_count]`, quantity);
            formData.append(`items[${variantId}][properties][_bundle_discount_percentage]`, bundleDiscountPercentage);
          }
          formData.append(`items[${variantId}][id]`, variantId);
          formData.append(`items[${variantId}][quantity]`, quantity);
        });
      }

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      let productGroup = this.closest('.product')?.querySelector('product-group');

      if(productGroup){

        let productGroupCurrent = productGroup.dataset.selectedType;
        let productGroupCurrentItem = productGroupCurrent.split(":");
        let productGroupType = productGroupCurrentItem[0].trim();
        let productGroupData = productGroupCurrentItem[1].trim();

        formData.set(`[properties][${productGroupType}]`, productGroupData)
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            // GTM Datalayer Tracking
            dataLayer.push({
              event: 'eec.add',
              ecommerce: {
                currencyCode: response.currency,
                add: {
                  actionField: {
                    list: 'Basket',
                  },
                  products: [
                    {
                      name: response.product_title,
                      id: response.variant_id.toString(),
                      price: (response.line_price / 100).toFixed(2),
                      brand: response.vendor,
                      category: document.querySelector('#product-main')?.dataset.collectionTitle || 'Uncategorized',
                      variant: response.variant_title,
                      quantity: response.quantity,
                    },
                  ],
                },
              },
            });

            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');

          // GTM Datalayer Tracking
          dataLayer.push({
            event: 'eec.add',
            ecommerce: {
              currencyCode: response.currency,
              add: {
                actionField: {
                  list: 'Basket',
                },
                products: [
                  {
                    name: response.product_title,
                    id: response.variant_id.toString(),
                    price: (response.line_price / 100).toFixed(2),
                    brand: response.vendor,
                    category: document.querySelector('#product-main')?.dataset.collectionTitle || 'Uncategorized',
                    variant: response.variant_title,
                    quantity: response.quantity,
                  },
                ],
              },
            },
          });

          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            // this.cart.renderContents(response);
            // navigating to cart page rather then updating and opaning cart drawer
            window.location = window.routes.cart_url;
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');

          if (this.stickyATCButton) {
            this.stickyATCButton.classList.remove('loading');
            if (!this.error) this.stickyATCButton.removeAttribute('aria-disabled');
            this.stickyATCButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
          }
        });
    }

    handleErrorMessage(errorMessage = false) {

      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
